import React from 'react';
import Routers from './Routes';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
